import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SentimentColor from "components/design/SentimentColor";
import { Topic } from "components/widgets/charts/TopicsTreeMap/TopicsTreeMap";

export default function TopicsTooltip(props: { topic: Topic, withCount?: boolean }) {
  const { i18n } = useTranslation();
  const topic = props.topic;

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: topic.entity ? 0 : 1, color: "inherit" }}>
        {topic.label}
      </Typography>
      {topic.entity && 
        <Typography sx={{ mb: 1}}>
          {topic.entity.type}
        </Typography>
      }

      {topic.positivity && <Typography>
        {i18n.t("positivity")}: 
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          <SentimentColor positivity={topic.positivity}>
            {(topic.positivity * 100).toFixed(0)}%
          </SentimentColor>
        </Box>
      </Typography>}

      {topic.relevance && <Typography>
        {i18n.t("relevance")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {topic.relevance.toFixed(1)}
        </Box>
      </Typography>}

      {topic.est_total_count && props.withCount !== false && <Typography>
        {i18n.t("record-count")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {i18n.t('intlNumber', { val: topic.est_total_count })}
        </Box>
      </Typography>}
      {topic.distribution && <Typography>
        {i18n.t("distribution")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {(topic.distribution * 100).toFixed(topic.distribution < 0.01 ? 2 : 1)}%
        </Box>
      </Typography>}
      {topic.velocity && <Typography>
        {i18n.t("velocity")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {(topic.velocity * 100).toFixed(topic.velocity < 0.01 ? 2 : 1)}
        </Box>
      </Typography>}
    </Box>
  );
}
